var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    fillRule: "evenodd",
    d: "M19.64 11.205q-.002-.958-.164-1.841H11v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    fillRule: "evenodd",
    d: "M11 20c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H2.957v2.332A9 9 0 0 0 11 20",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    fillRule: "evenodd",
    d: "M5.964 12.71A5.4 5.4 0 0 1 5.682 11c0-.593.102-1.17.282-1.71V6.958H2.957A9 9 0 0 0 2 11c0 1.452.348 2.827.957 4.042z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    fillRule: "evenodd",
    d: "M11 5.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C15.462 2.891 13.426 2 11 2a9 9 0 0 0-8.043 4.958L5.964 9.29C6.672 7.163 8.656 5.58 11 5.58",
    clipRule: "evenodd"
  })));
};
export default SvgGoogle;